var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardSnsSelected = function SvgIconDashboardSnsSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.42 19.19a9.089 9.089 0 1 0 .001-18.178 9.089 9.089 0 0 0 0 18.178ZM1.332 10.102h18.189M10.42 19.189V1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.421 19.19c-2.766 0-5.01-4.067-5.01-9.09s2.244-9.088 5.01-9.088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.42 1c2.767 0 5.011 4.067 5.011 9.089s-2.244 9.089-5.011 9.089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M3.387 15.869c1.666-1.123 4.2-1.834 7.033-1.834s5.345.711 7.022 1.822M17.454 4.32c-1.667 1.123-4.2 1.834-7.033 1.834S5.076 5.443 3.398 4.33"
  })));
};
export default SvgIconDashboardSnsSelected;